import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Import axios for making HTTP requests
import { Form, Alert } from 'react-bootstrap'; // Import Form and Alert components from react-bootstrap
import { uploadImage } from '../../utils/imageUpload';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSave, faFileUpload } from "@fortawesome/free-solid-svg-icons";
import HeaderPages from "../../Components/HeaderPages/HeaderPages";
import "./Projects.css";

const DentalTourism = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [key, setKey] = useState("-OEs4mKEMS95C8kd99qmM"); // Example key
  const [imageUrl, setImageUrl] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]); // Set the selected file
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !description) {
      setStatus({ type: 'danger', message: "Title and Description are required" });
      return;
    }

    setLoading(true);
    try {
      // If a new image is selected, upload it
      let uploadedImageUrl = imageUrl;
      if (image) {
        uploadedImageUrl = await uploadImage(image);
      }

      // Prepare data for Firebase Realtime Database
      const updatedData = {
        title,
        description,
        imageUrl: uploadedImageUrl
      };

      // Update data in the Firebase Realtime Database at the specific key
      await axios.put(`https://cdcn-cca59-default-rtdb.firebaseio.com/dentalTourism/${key}.json`, updatedData);

      setStatus({ type: 'success', message: "Data updated successfully" });
      setImage(null);  // Clear selected file after successful save
      setImageUrl(uploadedImageUrl);  // Update the image URL after a successful upload
    } catch (error) {
      console.error("Error updating data: ", error);
      setStatus({ type: 'danger', message: "Error updating data. Check console for details." });
    } finally {
      setLoading(false);
    }
  };

  // Optional: Load existing data for editing (you can fetch the data by key)
  const loadData = async () => {
    try {
      const response = await axios.get(`https://cdcn-cca59-default-rtdb.firebaseio.com/dentalTourism/${key}.json`);
      const data = response.data;
      if (data) {
        setTitle(data.title);
        setDescription(data.description);
        setImageUrl(data.imageUrl);  // Set the existing image URL from Firebase
        setImage(null);  // Do not preload the image, keep it empty to re-upload
      }
    } catch (error) {
      console.error("Error loading data for editing: ", error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="project-management-request all-main my-projects-container">
      {/* Breadcrumb Navigation */}
      <HeaderPages titlePage="Update Dental Tourism" />

      <div className="clinic-card">
        <h3 className="clinic-card-title">
          <FontAwesomeIcon icon={faPen} style={{ color: "var(--blue-main-color)" }} />
          Update Dental Tourism Content
        </h3>
        
        {/* Displaying Alert for Success or Failure */}
        {status && (
          <Alert variant={status.type} className="mb-4">
            {status.message}
          </Alert>
        )}
        
        <Form onSubmit={handleSubmit} className="clinic-form-grid">
          {/* Title Input */}
          <Form.Group className="mb-1">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              style={{ padding: "12px", borderRadius: "10px" }}
            />
          </Form.Group>

          {/* Description Input */}
          <Form.Group className="mb-1">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
              style={{ padding: "12px", borderRadius: "10px" }}
            />
          </Form.Group>

          {/* Image Input */}
          <Form.Group className="mb-1">
            <Form.Label>Upload Tourism Banner Image</Form.Label>
            <div className="custom-file-upload-box">
              <input
                id="floatingImage"
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
              <label htmlFor="floatingImage">
                <FontAwesomeIcon icon={faFileUpload} style={{ fontSize: "24px", marginBottom: "6px" }} />
                <span>{image ? image.name : "Click here to choose a new image file"}</span>
              </label>
            </div>
          </Form.Group>

          {/* Display current image if exists */}
          {imageUrl && !image && (
            <div className="current-image-preview mb-3">
              <Form.Label className="d-block text-muted">Current Tourism Banner Image:</Form.Label>
               <img src={imageUrl} alt="Current" />
            </div>
          )}

          {/* Submit Button */}
          <button className="btn-save-section d-flex align-items-center gap-2 justify-content-center" type="submit" disabled={loading}>
            {loading ? (
              <span className="loader"></span>
            ) : (
              <>
                <FontAwesomeIcon icon={faSave} />
                <span>Update Dental Tourism Section</span>
              </>
            )}
          </button>
        </Form>
      </div>
    </div>
  );
};

export default DentalTourism;
